import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Area } from '../../../core/constants/area';
import { JobLog } from './models/job-log.model';
import { JobLogFilter } from './models/job-log-filter.model';
import { ApiResponse } from '../../../shared/models/apiResponse.model';

@Injectable()
export class JobLogsService {

  constructor(private httpClient: HttpClient) { }

  getJobLogs(filter: JobLogFilter) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/jobLogs`;

    let params = new HttpParams();

    if (filter.startDate) {
      params = params.append('startDate', new Date(filter.startDate).toUTCString());
    }

    if (filter.endDate) {
      params = params.append('endDate', new Date(filter.endDate).toUTCString());
    }

    if (filter.logTypeId) {
      params = params.append('logTypeId', filter.logTypeId.toString());
    }

    if (filter.userId) {
      params = params.append('userId', filter.userId);
    }

    if (filter.searchText) {
      params = params.append('searchText', filter.searchText);
    }

    if (filter.errorsOnly) {
      params = params.append('errorsOnly', filter.errorsOnly.toString());
    }

    params = params.append('utcOffset', new Date().getTimezoneOffset().toString());
    return this.httpClient.get<ApiResponse<Array<JobLog>>>(url, { params: params });
  }

  getJobLogById(id: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/jobLogs/${id}`;

    return this.httpClient.get<ApiResponse<JobLog>>(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/logs/job-logs/job-logs.service.ts